import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToInstance } from 'class-transformer';
import { Observable } from 'rxjs';
import { mapResponse } from 'src/lib/utilities/api/map-response';
import {
	StudentPropertyEditArgument,
	StudentPropertyModel,
	StudentPropertyValueModel,
} from './student-properties.model';

@Injectable({
	providedIn: 'root',
})
export class StudentPropertiesService {
	constructor(private httpClient: HttpClient) {}

	public getStudentProperties = (
		uid: number,
	): Observable<StudentPropertyValueModel[]> => {
		return this.httpClient
			.get<StudentPropertyValueModel[]>(`/api/v1/students/${uid}/properties`)
			.pipe(
				mapResponse((r) => plainToInstance(StudentPropertyValueModel, r), {
					errorCode: '715B1ED0',
				}),
			);
	};

	public editStudentProperty = (
		uid: number,
		args: StudentPropertyEditArgument,
	): Observable<unknown> => {
		return this.httpClient
			.post<unknown>(`/api/v1/students/${uid}/properties`, args)
			.pipe(
				mapResponse((r) => plainToInstance(StudentPropertyValueModel, r), {
					errorCode: 'F1E01737',
				}),
			);
	};

	public deleteStudentProperty = (
		uid: number,
		key: string,
	): Observable<unknown> => {
		return this.httpClient
			.post<unknown>(`/api/v1/students/${uid}/properties/delete`, {
				key,
			})
			.pipe(
				mapResponse((r) => plainToInstance(StudentPropertyValueModel, r), {
					errorCode: '98BB3CD7',
				}),
			);
	};

	public getPropertyOptions = (): Observable<StudentPropertyModel[]> => {
		return this.httpClient
			.get<StudentPropertyModel[]>(`/api/v1/students/properties/options`)
			.pipe(
				mapResponse((r) => plainToInstance(StudentPropertyModel, r), {
					errorCode: '14B10DF3',
				}),
			);
	};
}
